import React, { useState } from "react";
// import AdminAccountTab1 from "./AdminAccountTab1";
// import AdminAccountTab2 from "./AdminAccountTab2";
import "../../../style/_main.scss";
import FirstTab from "./teammemberTab/firstTab";
import SecondTab from "./teammemberTab/secondTab";
import { useTranslation } from "react-i18next";
const TeamMember = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);
  const handleTabClick = (index) => {
    setActiveTab(index);
  };
  return (
    <div>
      <div className="teamMember">
        <div className="teamMember-content">
          <div className="main-profile">
            <div className="main-primary">
              {/* <div className="profile-heading">
                <span className="SellerProfile">Seller Profile</span>
              </div> */}
              <div className="tabs-content">
                <div className="tabs-container">
                  <div className="tabs mb-2">
                    <a
                      className={`tab ${activeTab === 0 ? "active" : ""} `}
                      onClick={() => handleTabClick(0)}
                    >
                      {t("Team_Members")}
                    </a>
                    <a
                      className={`tab ${activeTab === 1 ? "active" : ""}`}
                      onClick={() => handleTabClick(1)}
                    >
                      {t("Groups")}
                    </a>
                  </div>
                  <div className="tab-content">
                    <div
                      className={`tab-pane ${activeTab === 0 ? "active" : ""}`}
                    >
                      {/* <AdminAccountTab1 /> */}
                      <FirstTab />
                    </div>
                    <div
                      className={`tab-pane ${activeTab === 1 ? "active" : ""}`}
                    >
                      {/* <AdminAccountTab2 /> */}
                      <SecondTab />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamMember;
